import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react';
import { CardBody } from 'reactstrap';

const hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const generateStudentSentimentOptions = (
  responseData,
  yAxisTitle,
  xAxisTitle,
  colors = ['#A2EAB3', '#FFE5CD', '#F79496'],
) => {
  const sortedDates = Object.keys(responseData).sort((a, b) => {
    const [dayA, monthA, yearA] = a.split('-');
    const [dayB, monthB, yearB] = b.split('-');
    return (
      new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB)
    );
  });

  const positiveData = sortedDates.map((date) => responseData[date].positive);
  const neutralData = sortedDates.map((date) => responseData[date].neutral);
  const negativeData = sortedDates.map((date) => responseData[date].negative);

  return {
    chart: {
      type: 'column', // vertical grouped bars
      backgroundColor: 'transparent',
    },
    title: { text: null },
    xAxis: {
      categories: sortedDates,
      crosshair: true,
      title: { text: xAxisTitle },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: { text: yAxisTitle },
      labels: {
        formatter: function () {
          return this.value + '%';
        },
      },
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      x: 0,
      y: 30,
    },
    tooltip: {
      shared: true,
      pointFormat: '<span >{series.name}</span>: <b>{point.y}%</b><br/>',
    },
    plotOptions: {
      column: {
        pointWidth: 11, // You can adjust this
        dataLabels: {
          enabled: true,
          color: 'black',
          style: { fontSize: '10px', fontWeight: 'bold' },
          verticalAlign: 'middle',
          align: 'left',
          crop: false,
          overflow: 'none',
          x: 10,
          // y: -10,

          formatter: function () {
            if (this.y === 0) return;
            return this.y + '%';
          },
        },
      },
      series: {
        stacking: 'normal',
      },
    },
    series: [
      {
        name: 'Negative',
        data: negativeData,
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, hexToRGBA(colors[2], 1)],
            [1, hexToRGBA(colors[2], 0.3)],
          ],
        },
      },
      {
        name: 'Neutral',
        data: neutralData,
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, hexToRGBA(colors[1], 1)],
            [1, hexToRGBA(colors[1], 0.3)],
          ],
        },
      },
      {
        name: 'Positive',
        data: positiveData,
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, hexToRGBA(colors[0], 1)],
            [1, hexToRGBA(colors[0], 0.3)],
          ],
        },
      },
    ],
    credits: { enabled: false },
    exporting: {
      enabled: true,
      chartOptions: {
        title: { text: 'Student Sentiment' },
      },
    },
  };
};

const StudentSentimentChart = ({
  options,
  yAxisTitle = '% of Sessions',
  xAxisTitle = 'Week',
}) => {
  const [studentSentimentOptions, setstudentSentimentOptions] = useState(null);

  useEffect(() => {
    setstudentSentimentOptions(
      generateStudentSentimentOptions(options, yAxisTitle, xAxisTitle),
    );
  }, [options, yAxisTitle, xAxisTitle]);

  if (!options || !studentSentimentOptions) return;

  return (
    <div>
      <CardBody>
        <div className="">
          <h5 className="f-16 bold d-flex align-items-center mb-3">
            Student Sentiment (%)
          </h5>
          <HighchartsReact
            highcharts={Highcharts}
            options={studentSentimentOptions}
          />
        </div>
      </CardBody>
    </div>
  );
};

export default StudentSentimentChart;
